import {showNotification} from 'platform/components';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {
  useAddFilesToSaleVehicleAlbumMutation,
  useLazyListSaleVehicleAlbumsByVehicleQuery,
} from '@dms/api/vehicle';
import {handleApiError} from '@dms/shared';

import {Nullish} from 'shared/web';

export type SaleVehicleTargetAlbum = 'PHOTOS_CAR_SALES' | 'PHOTOS_CAR_PURCHASE';

export const useAttachPhotosToSaleVehicleAlbum = () => {
  const [listSaleVehicleAlbumsByVehicle] = useLazyListSaleVehicleAlbumsByVehicleQuery();
  const [addFilesToSaleVehicleAlbum] = useAddFilesToSaleVehicleAlbumMutation();

  const attachPhotos = async (
    vehicleId: string,
    photos: {fileId: string}[] | Nullish,
    targetAlbum: SaleVehicleTargetAlbum
  ) => {
    if (isNilOrEmpty(photos)) {
      return;
    }

    await listSaleVehicleAlbumsByVehicle({vehicleId})
      .unwrap()
      .then((albums) => {
        const album = albums.find(
          (vehicleAlbum) => vehicleAlbum.active && vehicleAlbum.name === targetAlbum
        );

        if (isNil(album)) {
          showNotification.error();
          return;
        }

        return addFilesToSaleVehicleAlbum({
          saleVehicleAlbumId: album.id,
          addFilesToSaleVehicleAlbumRequestBody: {
            fileIds: photos?.map((photo) => photo.fileId) ?? [],
          },
        }).unwrap();
      })
      .catch(handleApiError);
  };

  return {attachPhotos};
};
